module.exports = __webpack_public_path__ + "images/icon-onboarding-google.png";